// src/hooks/usePageData.jsx
import { useState, useEffect } from 'react';
import { normalizeApiError } from '../services/api';

/**
 * Универсальный хук для загрузки данных с обработкой ошибок
 * @param {Function} fetchFn - Асинхронная функция загрузки данных
 * @param {Array} deps - Зависимости для useEffect
 * @returns {Object} { data, loading, error, retry }
 */
export function usePageData(fetchFn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await fetchFn();
      setData(result);
    } catch (err) {
      console.error('Data loading error:', err);

      // Определяем код ошибки для ErrorPage
      let errorCode = '500';

      if (!err.response) {
        errorCode = 'network';
      } else if (err.response.status === 404) {
        errorCode = '404';
      } else if (err.response.status === 403) {
        errorCode = '403';
      }

      // Сохраняем объект ошибки.
      setError({
        code: errorCode,
        message: null,
        originalError: normalizeApiError(err)
      });

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // Комментарий удален, так как он вызывал ошибку сборки
  }, deps);

  return {
    data,
    loading,
    error,
    retry: loadData,
  };
}
